import { actionTemplatesApi } from 'config/api/actionLibrary/actionLibrary';
import { ACTION_TEMPLATE_OWNER_TYPE_TO_MESSAGE_KEY, ActionTemplateOwnerType } from 'config/api/actionLibrary/actionLibrary.types';
import action_library_messages from 'messages/action_library_messages';

// Helper function to convert ChoiceItem[] to filter format
const convertChoicesToFilters = (choices: { value: string; label: string }[]) =>
  choices.map(choice => ({ id: choice.value, name: choice.label }));

// Purpose filter - uses API choices
export const getPurposeFilter = async () => {
  const { data } = await actionTemplatesApi.getChoices();
  return {
    sectionName: action_library_messages.filters.purpose,
    filters: convertChoicesToFilters(data.purpose),
  };
};

// Area filter - uses API choices
export const getAreaFilter = async () => {
  const { data } = await actionTemplatesApi.getChoices();
  return {
    sectionName: action_library_messages.filters.area,
    filters: convertChoicesToFilters(data.area),
  };
};

// Criticality filter - uses API choices
export const getCriticalityFilter = async () => {
  const { data } = await actionTemplatesApi.getChoices();
  return {
    sectionName: action_library_messages.filters.criticality,
    filters: convertChoicesToFilters(data.criticality),
    isSingleSelect: false,
  };
};

// Creator filter - uses API choices (owner_type)
export const getCreatorFilter = async () => {
  const { data } = await actionTemplatesApi.getChoices();
  return {
    sectionName: action_library_messages.filters.creator,
    filters: data.ownerType.map(choice => {
      const messageKey = ACTION_TEMPLATE_OWNER_TYPE_TO_MESSAGE_KEY[choice.value as ActionTemplateOwnerType];
      return {
        id: choice.value,
        name: messageKey ? action_library_messages.owner_type[messageKey] : choice.label,
      };
    }),
  };
};

// Status filter - uses API choices
export const getStatusFilter = async () => {
  const { data } = await actionTemplatesApi.getChoices();
  return {
    sectionName: action_library_messages.filters.status,
    filters: convertChoicesToFilters(data.status),
  };
};

// Subarea filter - dynamic, depends on selected area
// Note: This needs to be handled dynamically in the component based on selected area
export const getSubareaFilter = async (area?: string) => {
  if (!area) {
    return {
      sectionName: action_library_messages.filters.subarea,
      filters: [],
    };
  }

  try {
    const { data } = await actionTemplatesApi.getSubareas(area);
    return {
      sectionName: action_library_messages.filters.subarea,
      filters: data.subareas.map((subarea: any) => ({
        id: subarea?.value ?? subarea?.id ?? subarea,
        name: subarea?.label ?? subarea?.name ?? subarea,
      })),
    };
  } catch (error) {
    return {
      sectionName: action_library_messages.filters.subarea,
      filters: [],
    };
  }
};

// Legacy exports for backward compatibility (will be replaced with async versions)
export const purposeFilter = {
  sectionName: action_library_messages.filters.purpose,
  filters: [],
};

export const areaFilter = {
  sectionName: action_library_messages.filters.area,
  filters: [],
};

export const criticalityFilter = {
  sectionName: action_library_messages.filters.criticality,
  filters: [],
  isSingleSelect: false,
};

export const creatorFilter = {
  sectionName: action_library_messages.filters.creator,
  filters: [],
};
